/*eslint-disable*/
import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

function IrnCodeRender(props) {
    return (
        <>
            {
                props?.data?.eInvIntegratedReferenceNumberErrorContent ?
                    <Button basic className="w3-tiny ml-2" style={{ color: "#006837" }} circular type="button" icon>
                        <Icon name="info" size='small' style={{ color: "#006837" }} title={props.data.eInvIntegratedReferenceNumberErrorContent} />
                    </Button>
                    :
                    <>
                        {props?.data?.irnCode ?
                            <>
                                {props?.data?.irnCode}
                                <Button basic className="w3-tiny ml-2" style={{ color: "#006837" }} circular type="button" icon>
                                    <Icon name="copy" size='small' style={{ color: "#006837" }} onClick={() => { navigator.clipboard.writeText(props?.data?.irnCode || 'NA') }} />
                                </Button>
                            </>
                            : null
                        }
                    </>
            }
        </>
    )
}

export default IrnCodeRender
